function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDoubleRight = function SvgChevronDoubleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.882 1.746a.75.75 0 011.055.106L8.58 7.527a.75.75 0 010 .95l-4.643 5.675a.75.75 0 11-1.16-.95l4.254-5.2-4.255-5.2a.75.75 0 01.106-1.056zm5.484 0a.75.75 0 011.055.106l4.644 5.675a.75.75 0 010 .95L9.42 14.152a.75.75 0 11-1.16-.95l4.254-5.2-4.254-5.2a.75.75 0 01.105-1.056z",
    fill: props.fill
  }));
};
export default SvgChevronDoubleRight;